import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

export function SequencesIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      <path d="M80 50v12M80 88v12M80 126v8" stroke={c.p300} strokeWidth="3" />
      <rect x="40" y="24" width="80" height="26" rx="10" fill={c.p500} />
      <rect x="60" y="34" width="40" height="6" rx="3" fill={c.n0} />
      <rect
        x="40"
        y="62"
        width="80"
        height="26"
        rx="10"
        fill={c.n0}
        stroke={c.p200}
        strokeWidth="2"
      />
      <rect x="60" y="72" width="40" height="6" rx="3" fill={c.p300} />
      <rect
        x="40"
        y="100"
        width="80"
        height="26"
        rx="10"
        fill={c.n0}
        stroke={c.p200}
        strokeWidth="2"
      />
      <rect x="60" y="110" width="40" height="6" rx="3" fill={c.p300} />
      <circle cx="80" cy="56" r="4" fill={c.a400} />
      <circle cx="80" cy="94" r="4" fill={c.a400} />
      <circle cx="80" cy="134" r="4" fill={c.p300} />
    </Frame>
  );
}
